export default __webpack_public_path__ + "static/media/history-line.d1f3af6e.svg";